import 'bootstrap'

import './directives'

import './components'
import './layout'

import App from './app'

App.mount('#app')
